import { set } from 'date-fns';

export function closestTwiceMonthlyDate(date: Date) {
  if (!date) {
    throw new Error('Please provide a valid Date object.');
  }
  if ([1, 15].includes(date.getDate())) {
    return date;
  }

  const currentDay = date.getDate();
  const currentMonth = date.getMonth();

  const newMonth = currentDay > 1 && currentDay <= 15 ? currentMonth : currentMonth + 1;

  const newDay = currentDay > 1 && currentDay <= 15 ? 15 : 1;

  return set(date, { date: newDay, month: newMonth });
}
